const types = require('../../constants/actionTypes');

const fetchSubCategories = response => ({
    type: types.FUNDS_FETCH_SUB_CATEGORIES,
    payload: response
});

module.exports = fetchSubCategories;
